module.exports = __webpack_public_path__ + "img/total_installed_projects_per_year.b55647b5.png";